import { render } from "./DataSync.vue?vue&type=template&id=2043ab68&scoped=true"
import script from "./DataSync.vue?vue&type=script&lang=js"
export * from "./DataSync.vue?vue&type=script&lang=js"

import "./DataSync.vue?vue&type=style&index=0&id=2043ab68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2043ab68"]])

export default __exports__